import { render, staticRenderFns } from "./OtpBox.vue?vue&type=template&id=619ac52c&lang=pug&"
import script from "./OtpBox.vue?vue&type=script&lang=js&"
export * from "./OtpBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports